import { createFileRoute } from '@tanstack/react-router'
import COntactDetailsView from '@web/contacts/components/ContactDetailsView'

export const Route = createFileRoute(
  '/dashboard/admin/contact/details/$contactId',
)({
  component: () => <COntactDetailsView></COntactDetailsView>,
  notFoundComponent: () => {
    return <p>Post not found</p>
  },
})
